import { render, staticRenderFns } from "./RoleDataruleModal.vue?vue&type=template&id=7832aa3a&scoped=true"
import script from "./RoleDataruleModal.vue?vue&type=script&lang=js"
export * from "./RoleDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832aa3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7832aa3a')) {
      api.createRecord('7832aa3a', component.options)
    } else {
      api.reload('7832aa3a', component.options)
    }
    module.hot.accept("./RoleDataruleModal.vue?vue&type=template&id=7832aa3a&scoped=true", function () {
      api.rerender('7832aa3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/RoleDataruleModal.vue"
export default component.exports